import defaultActions from './defaultReduxActions';

const actions = defaultActions({ namespace: 'facilities' });

export const { find, create, get, patch, reducer, remove } = actions;

export default reducer;
